export default [
  {
    name: 'noDeposit',
    labelKey: 'search.filter.noDeposit',
    tracking: 'ga-search-form-noDeposit',
    cy: 'advanced-noDeposit',
    tooltipTextKey: 'search.filter.noDeposit.tooltip'
  }
];
